import React, { FC, useCallback, useEffect, useState } from "react";
import { Spin, Tabs } from "antd";
import AlertsCard from '@components/drawerAlerts/alerts';
// @ts-ignore
import { VariableSizeList as List } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";
// import Masonry from "react-responsive-masonry";
import './drawerAlerts.scss';
import { DataOptions, TAlertsProps, tabs } from "./constant";
import membersService from "@services/members.service";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { get, uniqBy, clone, cloneDeep } from "lodash";
import { useMemberListStore } from "@stores/useMemberListStore";
import Icon from "@assets/icon_config";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_AVAILABLE } from "../../constants/constants";
const { TabPane } = Tabs;

const Alerts: FC<TAlertsProps> = ({ members, updateMembers, searchValue, filterValue, filterStartDate, filterEndDate, showRightActionBar }) => {

  const memberDetailGlobalAlert = useGlobalInformationStore((state) => state.memberDetailGlobalAlert);
  const setMemberDetailGlobalAlert = useGlobalInformationStore((state) => state.setMemberDetailGlobalAlert);
  const page = useMemberListStore((state) => state.alertPage);
  const setPage = useMemberListStore((state) => state.setAlertPage);
  const [isSearch, setIsSearch] = useState(false);
  const [alertLoader, setAlertLoader] = useState(false);
  const location = useLocation()
  const [ref, setref] = useState<any>()
  const [height, setheight] = useState<number>();
  useEffect(
    () => {
      let listHeight = document.querySelector(".right-drawer .ant-drawer-body")?.clientHeight || 500;
      let headerHeight = document.querySelector(".right-drawer .ant-drawer-body .header .ant-tabs .ant-tabs-nav")?.clientHeight || 40;
  
      setheight(listHeight - headerHeight - 45);
    },
    []
  )
  const alertReadStatusHandler = (data: DataOptions) => {
    let memberDetailGlobalAlertClone = cloneDeep(memberDetailGlobalAlert)
    memberDetailGlobalAlertClone?.alerts.map((item: any) => {
      if (item.alertId === data?.alertId) {
        item.alertReadStatus = 'Y';
        // item.alertDate = moment.now();
      }
      return item;
    });

    // updateMembers(old);
    setMemberDetailGlobalAlert(memberDetailGlobalAlertClone);
  };
  useEffect(
    () => {
      if (ref) {
        ref.resetAfterIndex(0, true)
      }
    },
    [memberDetailGlobalAlert?.alerts]
  )
  useEffect(() => {
    if(!showRightActionBar){
      setPage(1)
    }
  },[showRightActionBar])
  const onNoteShowMore = (index: number, isShowMore: boolean) => {
    if (memberDetailGlobalAlert?.alerts) {
      let alerts = clone(memberDetailGlobalAlert?.alerts)
      alerts[index].isShowMore = isShowMore
      setMemberDetailGlobalAlert(alerts)
    }
  }


  useEffect(() => {
    console.log("Alerts.useEffect2");

    const formatTheDate = (date: any, type: any) => {
      const tempDate = moment(date).format("YYYY-MM-DD")
      if (type === 'startDate') {
        return moment.utc(moment(`${tempDate} 00:00:00`).utc());
      }
      else {
        return moment.utc(moment(`${tempDate} 23:59:59`).utc());
      }
    }
    const filteredStartDate = formatTheDate(filterStartDate, 'startDate');
    const filteredEndDate = formatTheDate(filterEndDate, 'endDate');
    let filters = {
      searchValue: searchValue.length >= 3 ? searchValue : null,
      filterStartDate: filteredStartDate ? filteredStartDate : null,
      filterEndDate: filteredEndDate ? filteredEndDate : null
    }
    if (searchValue.length >= 3 && searchValue !== null && searchValue !== "") {
      if (memberDetailGlobalAlert?.alerts?.length !== 0 || isSearch) {
        fetchSearchAlerts(1, filters)
        setPage(1);
        setIsSearch(true)
      }
    }
    if (searchValue === null || searchValue === "") {
      fetchSearchAlerts(1, filters)
      setPage(1);
    }
    return () => {
      setMemberDetailGlobalAlert({alerts : [] , totalAlerts : 0 , latest_datetime : undefined , datetime : undefined});
    };
  }, [searchValue, filterValue, filterStartDate, filterEndDate])


  const getAlertsCard = (item: any) => {
    const Row: any = (props: any) =>
    memberDetailGlobalAlert?.alerts?.[props.index] ? (
        <div style={props.style}>
          <>
            <AlertsCard
              key={`alert_${props.index}`}
              data={memberDetailGlobalAlert?.alerts?.[props.index]}
              width='430px'
              className="notesCard"
              avatarSize={20}
              alertReadStatusHandler={alertReadStatusHandler}
              onShowMore={
                (isShowMore: boolean) => {
                  onNoteShowMore(props.index, isShowMore)
                }
              }
              tab={item.key}
            />
          </>
        </div>
      ) : null;

    return (
      <Spin spinning={alertLoader} indicator={<HealthemSpinner size={45} />}>
        {memberDetailGlobalAlert?.alerts?.length === 0 ? (
          <DataNotFound message={NO_DATA_AVAILABLE}/>
        ) : (
          <div className="allNotes">
            {height && (
              <InfiniteLoader
                isItemLoaded={(index: any) => index < memberDetailGlobalAlert?.alerts?.length}
                itemCount={
                  memberDetailGlobalAlert.alerts?.length >= 10 && memberDetailGlobalAlert?.totalAlerts > 10
                    ? memberDetailGlobalAlert?.alerts?.length < memberDetailGlobalAlert?.totalAlerts
                      ? memberDetailGlobalAlert?.alerts?.length + 1
                      : memberDetailGlobalAlert?.alerts?.length
                    : memberDetailGlobalAlert.alerts?.length
                }
                threshold={0}
                loadMoreItems={() => loadNextAlerts()}
              >
                {({ onItemsRendered, ref }: any) => (
                  <List
                    className="alert_list"
                    height={height}
                    width={"100%"}
                    itemCount={
                      memberDetailGlobalAlert.alerts?.length >= 10 && memberDetailGlobalAlert?.totalAlerts > 10
                        ? memberDetailGlobalAlert?.alerts?.length < memberDetailGlobalAlert?.totalAlerts
                          ? memberDetailGlobalAlert?.alerts?.length + 1
                          : memberDetailGlobalAlert?.alerts?.length
                        : memberDetailGlobalAlert.alerts?.length
                    }
                    itemSize={(index) => {
                      let alert = memberDetailGlobalAlert?.alerts?.[index];
                      let card = document.querySelector(`.ant-tabs-tabpane-active #drawer_alert_card_${item?.key}_${alert?.alertId}`);
                      return alert?.isShowMore ? (card?.clientHeight ? card?.clientHeight + 50 : 0) || 350 : (card?.clientHeight ? card?.clientHeight + 25 : 0) || 160;
                    }}
                    onItemsRendered={onItemsRendered}
                    ref={(ref) => setref(ref)}
                  >
                    {Row}
                  </List>
                )}
              </InfiniteLoader>
            )}
          </div>
        )}
      </Spin>
    );
  };


  const fetchSearchAlerts = (nextPage: number, filters?: any) => {
    setAlertLoader(true);
    let isAllCM = location.pathname === '/member-detail';
    let memberId = isAllCM ? members[0]?.patient_id : undefined;
    if(filters){
      membersService.getAllAlerts(isAllCM, memberId, nextPage, filters).subscribe({
        next: (v) => {
          const data = v.data.data;
          if (nextPage === 1) {
          let alertsArray = uniqBy([...data?.alerts], 'alertId').sort((a, b) => {
            const dateA = moment(a.alertDate);
            const dateB = moment(b.alertDate);
            return dateB.diff(dateA); // Compare in descending order
          })
          setMemberDetailGlobalAlert({ alerts: alertsArray, totalAlerts: data.totalCount});
        }
        else {
          let alertsArray = uniqBy([...memberDetailGlobalAlert?.alerts, ...data?.alerts], 'alertId').sort((a, b) => {
            const dateA = moment(a.alertDate);
            const dateB = moment(b.alertDate);
            return dateB.diff(dateA); // Compare in descending order
          })
          setMemberDetailGlobalAlert({ ...memberDetailGlobalAlert, alerts: alertsArray, totalAlerts: data.totalCount});
        }
          setAlertLoader(false);
        },
        error: (e) => {
          console.log(e);
          setAlertLoader(false);
        },
      });
    }
    else {
      membersService.getAllAlerts(isAllCM, memberId, nextPage).subscribe({
        next: (v) => {
          const data = v.data.data;
          let alertsArray = uniqBy([...memberDetailGlobalAlert?.alerts, ...data?.alerts], 'alertId').sort((a, b) => {
            const dateA = moment(a.alertDate);
            const dateB = moment(b.alertDate);
            return dateB.diff(dateA); // Compare in descending order
          })
          setMemberDetailGlobalAlert({ ...memberDetailGlobalAlert, alerts: alertsArray, totalAlerts: data.totalCount});
          setAlertLoader(false);
        },
        error: (e) => {
          console.log(e);
          setAlertLoader(false);
        },
      });
    }
  };


  const loadNextAlerts = () => {
      if (memberDetailGlobalAlert.alerts?.length >= 10 && memberDetailGlobalAlert?.totalAlerts > 10) {
        if (memberDetailGlobalAlert.alerts?.length < memberDetailGlobalAlert?.totalAlerts) {
          const nextPage: number = page + 1;
          setPage(nextPage);
          if (searchValue || filterStartDate || filterEndDate) {
            let filters = {
              searchValue: searchValue ? searchValue : "",
              filterStartDate: filterStartDate ? filterStartDate : "",
              filterEndDate: filterEndDate ? filterEndDate : ""
            }
            fetchSearchAlerts(nextPage, filters);
          }
          else {
            fetchSearchAlerts(nextPage);
          }
        }
      }
  }
  return (
    <div className="alertsWrapper">
      <div className="header">
        <Tabs defaultActiveKey={'1'} size="large" destroyInactiveTabPane>
          {
            tabs?.map((item: any) => {
              let count: any = memberDetailGlobalAlert?.totalAlerts;
              return (
                <TabPane tab={`${item.name} (${count})`} key={item.key}>
                  {getAlertsCard(item)}
                </TabPane>
              )
            })
          }
        </Tabs>
      </div>
      {/* </div> */}

    </div>
  );
};

export default Alerts;
